import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";

const RegisterPage: React.FC = () => {
  // Redirect to login since Auth0 handles both login and signup
  useEffect(() => {
    // Could add a brief message or redirect immediately
  }, []);

  return <Navigate to="/login" replace />;
};

export default RegisterPage;
